<o-menu
  [menu]="menu"
  [roles]="authService.userRole()"
  (oLogout)="logout()"
  [logo]="'../../assets/oLogo.svg'"
  [env]="environment"
  [user]="clientUser.user()"
  (oLanguageChange)="onLanguageChange($event)"
  [currentLanguage]="languageService.getCurrentLanguage()"
  [allowUserMenu]="true"
  [allowLanguageChange]="true"
  >
  <div class="app-container">
    <router-outlet></router-outlet>
  </div>
</o-menu>


@if (authService.showSessionExpire()) {
  <o-session-expired-component
  ></o-session-expired-component>
}
